import { useEffect, useState } from "react";
import type { HealthMapEdge, HealthMapNode } from "../../shared/types";
import { StateBlock } from "../components/common/StateBlock";
import { HealthMap } from "../components/health-map/HealthMap";
import { getHealthMap } from "../services/healthMapService";

interface HealthMapPageProps {
  refreshKey: number;
  onOpenJob: (jobId: string) => void;
}

export function HealthMapPage({ refreshKey, onOpenJob }: HealthMapPageProps) {
  const [nodes, setNodes] = useState<HealthMapNode[]>([]);
  const [edges, setEdges] = useState<HealthMapEdge[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string>();

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);
    setError(undefined);

    getHealthMap()
      .then((data) => {
        if (!isMounted) {
          return;
        }
        setNodes(data.nodes);
        setEdges(data.edges);
      })
      .catch((err: Error) => {
        if (isMounted) {
          setError(err.message);
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [refreshKey]);

  if (isLoading) {
    return <StateBlock type="loading" title="Loading health map" message="Mapping system dependencies." />;
  }

  if (error) {
    return <StateBlock type="error" title="Health map unavailable" message={error} />;
  }

  return (
    <section className="page-stack">
      <div className="page-heading">
        <div>
          <p>Dependency graph</p>
          <h2>Health Map</h2>
        </div>
      </div>

      <HealthMap nodes={nodes} edges={edges} onOpenJob={onOpenJob} />
    </section>
  );
}
